"use client";
import React, { useRef, useState } from "react";
import style from "./PassionateCards.module.scss";
import { useGSAP } from "@gsap/react";
import { gsap } from "@/utils/gsap";
import { DialogPostulation } from "../DialogPostulation/DialogPostulation";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";
import { MagneticChipButton } from "@/components/common/Buttons/MagneticChipButton/MagneticChipButton";
import { useTranslations } from "next-intl";

const PassionateCards = ({ messages }: any) => {
  const passionateRef = useRef(null);
  const [isContactPostulationOpen, setIsContactPostulationOpen] =
    useState(false);
  const [appliedPosition, setAppliedPosition] = useState();
  const translate = useTranslations("cursor");

  useGSAP(
    () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: `.${style.titleContainer}`,
          start: "top top",
          endTrigger: `.${style.jobList}`,
          end: "center center",
          scrub: true,
          invalidateOnRefresh: true,
          fastScrollEnd: true,
          pin: `.${style.titleContainer}`,
          pinSpacing: false,
        },
      });

      tl.to(`.${style.titleContainer}`, {
        filter: "blur(4px)",
        scale: 0.85,
        opacity: 0,
        delay: 0.1,
      });
    },
    { scope: passionateRef }
  );
  if (messages?.list_postulations?.length === 0)
    return <div className={style.spacing}></div>;
  return (
    <section className={style.sectionPassionate} ref={passionateRef}>
      <div className="container">
        <div className={style.titleContainer}>
          <TitleAnimation
            messages={{
              first_word: messages.first_words,
              second_word: messages.second_words,
            }}
          />
        </div>
        {messages.list_postulations ? (
          <ul className={style.jobList}>
            {messages.list_postulations.map((job, index) => (
              <li
                key={index}
                className={style.jobItem}
                data-hover="application"
                onClick={() => {
                  setIsContactPostulationOpen(true);
                  setAppliedPosition(job.title);
                }}
              >
                <h3 data-hover="application">{job.title}</h3>
                <p data-hover="application">{job.description}</p>
                <div className={style.jobTags} data-hover="application">
                  {job.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className={style.jobTag}
                      data-hover="application"
                    >
                      {tag}
                      {tagIndex !== job.tags.length - 1 && <small>+</small>}
                    </span>
                  ))}
                </div>
                <div className={style.btnPostulation}>
                  <MagneticChipButton
                    label={translate("apply")}
                    variant="outline"
                    onClick={() => {
                      setIsContactPostulationOpen(true);
                      setAppliedPosition(job.title);
                    }}
                    href={null}
                  />
                </div>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
      <DialogPostulation
        isContactOpen={isContactPostulationOpen}
        setIsContactOpen={setIsContactPostulationOpen}
        appliedPosition={appliedPosition}
      />
    </section>
  );
};

export default PassionateCards;
